<template>
  <v-card class="ma-3 pa-6" outlined tile>
    <v-img v-if="item.thumbnail_url != null" :src="item.thumbnail_url" width="100%" height="200px"></v-img>
    <v-card-title primary-title>
        <router-link :to="{path: '/product/'+course.googleCourseId, params: {id: course.googleCourseId}}">
          {{course.name}} 
        </router-link>
    </v-card-title>
    <v-card-subtitle>
      Price: {{course.pricePerCourse | currency}} per course<br/>
      Schedule: <span v-if="course.scheduleStart != null && course.scheduleEnd != null">{{scheduleStart}} - {{scheduleEnd}}</span>
          <span v-else>No schedule defined</span>
    </v-card-subtitle>
    <v-card-text>
      <div class="mb-5">
        {{course.description}}
        {{course.descriptionHeading}}
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="orange" :disabled="course.quantity === 0" @click="addItem">Add to Cart</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import moment from 'moment';

export default {
  props: ["item"],
  computed: {
    course() {
      return this.item;
    },
    scheduleStart(){
      return new moment(this.course.scheduleStart).format("ddd MMM DD, YYYY");
    },
    scheduleEnd(){
      return new moment(this.course.scheduleEnd).format("ddd MMM DD, YYYY");
    }
  },
  methods: {
    ...mapActions(["updateCart"]),
    addItem() {
      const order = {
        item: Object.assign({}, this.course),
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    }
  }
};
</script>
